"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("../../../utils");

var LocalTime_1 = require("../../date-time/LocalTime");

var Parser_1 = require("../Parser");

var parserSupport_1 = require("../parserSupport");

var ValidationResult_1 = require("../ValidationResult");
/**
 * @author VRu
 */


var LocalTimeParser =
/*#__PURE__*/
function (_Parser_1$Parser) {
  _inherits(LocalTimeParser, _Parser_1$Parser);

  function LocalTimeParser() {
    _classCallCheck(this, LocalTimeParser);

    return _possibleConstructorReturn(this, _getPrototypeOf(LocalTimeParser).apply(this, arguments));
  }

  _createClass(LocalTimeParser, [{
    key: "parse",
    value: function parse(input, level) {
      if (input instanceof LocalTime_1.LocalTime) {
        return parserSupport_1.succ(input);
      }

      if (!utils_1.Utils.isString(input)) {
        return parserSupport_1.badType(input, 'string');
      }

      var result = input.match(LocalTimeParser.REGEXP);

      if (!result) {
        return new ValidationResult_1.ValidationError(LocalTimeParser.BAD_FORMAT_ERROR);
      }

      return parserSupport_1.succ(new LocalTime_1.LocalTime(Number(result[1]), Number(result[2]), Number(result[3])));
    }
  }]);

  return LocalTimeParser;
}(Parser_1.Parser);

exports.LocalTimeParser = LocalTimeParser;
LocalTimeParser.BAD_FORMAT_ERROR = 'BAD_FORMAT';
LocalTimeParser.REGEXP = /(\d\d):(\d\d):(\d\d)/;